
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';

@Component
export default class Notification extends Vue {
  public desserts = [];
  public formTitle = 'اطلاع رسانی ها';
  public headers = [
    { text: 'تاریخ', value: 'notificationDate', align: 'start' },
    { text: 'موضوع', value: 'subject' },
    { text: 'پیام', value: 'content' },
    { text: '', value: 'action', sortable: false }
  ];
  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'اطلاع رسانی ها',
      disabled: true,
      href: ''
    }
  ];

  async created() {
    await this.initialize();
  }

  async initialize() {
    this.$showLoading();
    await Api.getNotifications().then((response: any) => {
      this.desserts = response.data;
      this.$hideLoading();
    });
  }
}
